export default "__VITE_ASSET__CvNJnlTK__"